import { toggleClass } from '../tools/helpers';

const accordeonItems = document.querySelectorAll('.accordeonItem');

accordeonItems.forEach((item) => {
  item.children[0].addEventListener('click', () => {
    toggleClass(item, 'accordeonItem--active');
  });
});



// WEBPACK FOOTER //
// ./src/javascript/main/accordeons.js